import React, {useEffect, useState} from 'react';
import './App.css';
import Step1 from "./components/steps/Step1";
import {SessionUserContext} from "./context/UserContext";
import {API_URL, StripeCustomer} from "./utils";
import PropertyData from "./components/PropertyData";
import AdminGoogleMapsAreaSelector from "./components/AdminGoogleMapsAreaSelector";

function App() {

    const [user, setUser] = useState<StripeCustomer | null>(null)
    const [location, setLocation] = useState<google.maps.GeocoderResult | null>(null)
    const [polygons, setPolygons] = useState<any[] | null>(null)

    const [isAdmin, setIsAdmin] = useState<boolean>(false)
    const [propertySize, setPropertySize] = useState<number|null>(null)

    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.has('admin')) {
            setIsAdmin(true)
        }
        if (url.searchParams.has('session')) {
            const session_id = url.searchParams.get('session');

            if(session_id) {
                const storedData = window.localStorage.getItem(session_id)

                if (storedData) {
                    const data = JSON.parse(storedData)
                    setUser(data.user)
                    setLocation(data.location)
                    setPolygons(data.polygons)
                }
            }
        }

    }, []);
    return (
        <div className="App">
            <SessionUserContext.Provider value={{
                user,
                location,
                polygons,
                propertySize,
                setUser: (user) => {
                    setUser(user)
                },
                setLocation: (location: google.maps.GeocoderResult) => {
                    setLocation(location)
                },
                setPolygons: (polygons: any[]) => {
                    setPolygons(polygons)
                },
                setPropertySize: (area: number) => {
                    setPropertySize(area)
                }
            }}>
                {isAdmin ? <AdminGoogleMapsAreaSelector/> : <section className={"uk-section uk-section-small uk-section-default"}>
                    <div className="uk-container">
                        <div className="uk-grid uk-child-width-expand@m" data-uk-grid>
                            <div>
                                {user?.id ? <PropertyData/> : <div className="uk-panel">
                                    <h2>
                                        Secure Premier Lawn Care Services in Just Two Minutes.
                                    </h2>
                                    <p>
                                        Completely insured, offering a comprehensive satisfaction guarantee and exceptional customer support.
                                    </p>
                                    <div className={"uk-margin-top"}>
                                        <Step1/>
                                    </div>
                                </div>}
                            </div>
                            {/*<div className={"uk-width-1-3@m"}>*/}
                            {/*    <img*/}
                            {/*        src={'https://www.lawndoctordenver.com/wp-content/uploads/2019/01/pest-control.png'}/>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </section>}
            </SessionUserContext.Provider>
        </div>
    );
}

export default App;
